<template>
  <div>
    <Title :pages="[{ icon: 'cog', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="content-main">
        <v-tabs v-model="tab" style="background-color: white">
          <v-tab v-for="item in items" :key="item.key">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-window v-model="tab">
          <v-tabs-window-item key="0">
            <StorageRules></StorageRules>
          </v-tabs-window-item>
          <v-tabs-window-item key="1">
            <ReposicionRules></ReposicionRules>
          </v-tabs-window-item>
          <v-tabs-window-item key="2">
            <PoliticasReposicion></PoliticasReposicion>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import StorageRules from "./StorageRules.vue";
import ReposicionRules from "./ReposicionRules.vue";
import PoliticasReposicion from "./PoliticasReposicion.vue";

export default {
  mixins: [],
  components: { Title, StorageRules, ReposicionRules, PoliticasReposicion },
  data() {
    return {
      page_title: "Reglas",
      tab: 0,
      items: [
        { tab: "Regla de guardado", key: 0 },
        { tab: "Regla de reposición", key: 1 },
        { tab: "Políticas de reposición", key: 2 },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
